import React, {useContext, useEffect} from 'react'
import {getStockById} from "../../../services/serviceStock";
import {AutoComplete, Form} from "antd";
import {OfferContext} from "../../../context/OfferContext";


const {Option} = AutoComplete

const OfferCreateStock = ({rowIndex, record}) => {
    const [form] = Form.useForm()
    const {materialInformation, stocks} = useContext(OfferContext)
    const [stockList] = stocks
    const [materials, setMaterials] = materialInformation

    useEffect(() => {
        form.setFieldsValue({
            [`${rowIndex}-stock`]: record.data ? getStockText() : ''
        })
    }, [rowIndex, record])

    const handleStockChange = (value, option) => {
        if (option.key) {
            getStockById(option.key)
                .then(({data}) => {
                    let mockContext = [...materials]
                    mockContext[rowIndex].data = data
                    mockContext[rowIndex].unitPrice = data.price || 0
                    mockContext[rowIndex].gift = false
                    setMaterials(mockContext)
                })
        }
    }

    const getStockText = () => `${record.data.code} - ${record.data.name} - ( ${record.data.quantity} )`

    return (
        <React.Fragment>
            <div className={'offer-stock'}>
                <Form form={form}>
                    <Form.Item name={`${rowIndex}-stock`}>
                        <AutoComplete
                            className={'auto-complete'}
                            dropdownClassName={'offer-stock-options'}
                            onChange={handleStockChange}
                            filterOption={(inputValue, option) =>
                                option.value.toLocaleLowerCase().indexOf(inputValue.toLocaleLowerCase()) !== -1
                            }
                        >
                            {stockList.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                </Form>
            </div>
        </React.Fragment>
    )
}
export default OfferCreateStock